module.exports = __webpack_public_path__ + "static/media/c35c8183-4cce-4fcf-803b-5b7abb7a897e.d0dbe684.JPG";